/**
 * TanStack Query hook for fetching deck cover slide IDs (deck_id ->
 * first_slide_id) for a specific set of decks. Decks carry no thumbnail
 * field, so cover previews need the first slide's ID, which
 * SlideThumbnailImage then resolves through the batch thumbnail cache.
 *
 * Scoped to the passed deck IDs so the backend never resolves covers for the
 * whole tenant — callers pass only the decks they actually render.
 */

import { useQuery } from "@tanstack/react-query"

import { fetchDeckCovers } from "../api"

export function useDeckCovers(deckIds: string[]) {
  // Sort for a stable cache key so reordering the same decks doesn't refetch.
  const key = [...deckIds].sort()
  return useQuery<Record<string, string>>({
    queryKey: ["slide-sense", "deck-covers", key],
    queryFn: () => fetchDeckCovers(deckIds),
    enabled: deckIds.length > 0,
    staleTime: 30_000,
  })
}
